<template>
  <div class="about_inner">
    <div class="left">
      <div class="image">
        <div
          class="main boxes_image"
          v-scroll-reveal="{ delay: 20 }"
          :style="{ backgroundImage: 'url(' + aboutImg + ')' }"
        ></div>
      </div>
      <!-- End image  -->
    </div>
    <!-- End left -->

    <div class="right">
      <div class="shane_tm_title">
        <span v-scroll-reveal="{ delay: 20 }">About Us</span>
        <h3 v-scroll-reveal="{ delay: 40 }">
          We Deliver Six Days a Week
        </h3>
      </div>
      <div class="text" v-scroll-reveal="{ delay: 60 }">
        <p style="margin-bottom: 20px;">
          We deliver to restauraunts in Northeast Florida six days a week, working closely with chefs. We provide an extensive list of spices, specialty ingredients, caviar, cheese, truffles, and all sorts of flavors and foods.
        </p>
        <div>
          <p style="margin-bottom: 10px">
            <b class="text-underline">Jax Metro area and Jacksonville Beaches including Ponte Vedra</b>
            <br/>
            Delivery 6 days a week. 
          </p>
          <p class="text-underline" style="margin-bottom: 10px">
            <b>Fernandina, Amelia Island</b>
            <br/>
            Delivery Wednesdays and Fridays
          </p>
          <p class="text-underline" style="margin-bottom: 10px">
            <b>Saint Augustine</b>
            <br/>
            Delivery on Thursdays
          </p>
        </div>
      </div>
      <!-- <div class="shane_tm_button" v-scroll-reveal="{ delay: 80 }">
        <a :href="cv" download>
          Download CV
        </a>
      </div> -->
    </div>
    <!-- End right -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      aboutImg: require("../../assets/img/backgrounds/box.png"),
      // cv: require("../../assets/img/resume/resume.jpg"),
    };
  },
};
</script>


<style lang="css">
.main.boxes_image {
  box-shadow: none !important;
}

</style>
